import { ExamType } from "../../types/types";

interface FiltersProps {
  error: string | null;
  examTypes: ExamType[];
  selectedExamTypeIds: number[];
  paymentStatus: "paid" | "unpaid" | "all";
  handleExamTypeSelection: (examType: ExamType) => void;
  registrationStatus: "paid" | "unpaid" | "incomplete" | "all";
  setPaymentStatus: (status: "paid" | "unpaid" | "all") => void;
  setRegistrationStatus: (
    status: "paid" | "unpaid" | "incomplete" | "all"
  ) => void;
}

const Filters = ({
  error,
  examTypes,
  selectedExamTypeIds,
  handleExamTypeSelection,
}: FiltersProps) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 mb-8">
      <h2 className="text-xl font-semibold mb-6 text-gray-800 dark:text-white">
        Filter Reports
      </h2>
      <div className="grid grid-cols-1 gap-6">
        {/* Exam Type Checkboxes */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Exam Types
          </label>
          <div className="max-h-40 overflow-x-auto flex flex-wrap gap-8 border border-gray-300 rounded-lg p-3 bg-white dark:bg-gray-900 dark:border-gray-700">
            {examTypes.map((examType) => (
              <label
                key={examType.id}
                className="flex items-center mb-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selectedExamTypeIds.includes(examType.id)}
                  onChange={() => handleExamTypeSelection(examType)}
                  className="mr-2 accent-blue-500"
                />
                <span className="text-gray-700 dark:text-gray-200 text-sm">
                  {examType.name}
                </span>
              </label>
            ))}
          </div>
        </div>

        {/* Registration Status */}
        {/* <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Registration Status
          </label>
          <select
            value={registrationStatus}
            onChange={(e) =>
              setRegistrationStatus(
                e.target.value as "paid" | "unpaid" | "incomplete" | "all"
              )
            }
            className="h-11 w-full appearance-none rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 pr-11 text-sm shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          >
            <option
              value="all"
              className="text-gray-700 dark:bg-gray-900 dark:text-gray-400"
            >
              All
            </option>
            <option
              value="paid"
              className="text-gray-700 dark:bg-gray-900 dark:text-gray-400"
            >
              Paid
            </option>
            <option
              value="unpaid"
              className="text-gray-700 dark:bg-gray-900 dark:text-gray-400"
            >
              Unpaid
            </option>
            <option
              value="incomplete"
              className="text-gray-700 dark:bg-gray-900 dark:text-gray-400"
            >
              Incomplete
            </option>
          </select>
        </div> */}

        {/* Payment Status */}
        {/* <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Payment Status
          </label>
          <select
            value={paymentStatus}
            onChange={(e) =>
              setPaymentStatus(e.target.value as "paid" | "unpaid" | "all")
            }
            className="h-11 w-full appearance-none rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 pr-11 text-sm shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          >
            <option
              value="all"
              className="text-gray-700 dark:bg-gray-900 dark:text-gray-400"
            >
              All
            </option>
            <option
              value="paid"
              className="text-gray-700 dark:bg-gray-900 dark:text-gray-400"
            >
              Paid
            </option>
            <option
              value="unpaid"
              className="text-gray-700 dark:bg-gray-900 dark:text-gray-400"
            >
              Unpaid
            </option>
          </select>
        </div> */}
      </div>

      {error && (
        <div className="mt-6 p-4 bg-red-50 border border-red-200 text-red-700 rounded-lg dark:bg-red-900/20 dark:border-red-800 dark:text-red-400">
          {error}
        </div>
      )}
    </div>
  );
};

export default Filters;
